import * as React from "react";
import {
  OverviewTitle,
  OverviewTitleWrapper,
} from "../../../components/Details/OverviewInfo/styles";
import {
  DetailInnerWrapper,
  DetailPageBox,
} from "../../../components/sharedStyles";
import ParkingCancellationsTable from "../../../components/Tables/ParkingSpotCancellations/FullTable";

import useActiveFilters from "../../../hooks/useActiveFilters";
import { buildQueryString } from "../../../store/base";

export default function ParkingSpotCancellations() {
  const { filteredRealEstates } = useActiveFilters();

  const persistantQuery = {
    realestate_ids: filteredRealEstates,
  };

  return (
    <DetailInnerWrapper>
      <DetailPageBox>
        <OverviewTitleWrapper>
          <OverviewTitle>Utflyttsöversikt</OverviewTitle>
        </OverviewTitleWrapper>

        <ParkingCancellationsTable persistantQuery={persistantQuery} />
      </DetailPageBox>
    </DetailInnerWrapper>
  );
}
